import React from 'react';
import { EyeOutlined } from '@ant-design/icons';
import { ScoreDateInfo } from './style';

import close_loan from '../../../assets/images/icons/ic_close_loan.svg';
import debt from '../../../assets/images/icons/ic_debt.svg';
import noburo_heart from '../../../assets/images/icons/ic_noburo_heart.svg';
import mission from '../../../assets/images/icons/ic_mission.svg';

const columns = [
  {
    title: 'ผู้ใช้งาน',
    render: (app) => (<>
      {app.user_fullname}
      <br />
      {app.user_phone}
    </>)
  },
  {
    title: 'พาร์ทเนอร์',
    dataIndex: 'partner_name',
  },
  {
    title: 'ผู้ให้สินเชื่อ',
    dataIndex: 'lender_name',
  },
  {
    title: 'ผลิตภัณฑ์',
    dataIndex: 'product_title',
  },
  {
    title: 'เลขที่ใบสมัคร',
    dataIndex: 'lms_app_id',
  },
  {
    title: 'เลขที่สัญญา',
    dataIndex: 'lms_loan_id',
  },
  {
    title: 'เหตุผลการปฏิเสธ',
    dataIndex: 'reject_reason',
  },
  {
    title: 'วงเงิน',
    dataIndex: 'amount',
  },
  {
    title: 'คะแนนเดือนก่อน',
    align: 'center',
    key: 'last_month_score',
    render: (app) => (<>
      <div>{app.last_month_score}</div>
      <ScoreDateInfo>{app.last_month_score_date}</ScoreDateInfo>
    </>)
  },
  {
    title: 'คะแนนมุ่งมั่น',
    align: 'center',
    key: 'current_score',
    render: (app) => (<>
      <div>{app.current_score}</div>
      <ScoreDateInfo>{app.current_score_date}</ScoreDateInfo>
    </>)
  },
  {
    title: 'ค่าบริการโนบูโร',
    dataIndex: 'payment_status',
  },
  {
    title: 'วันที่สมัคร',
    dataIndex: 'created_at'
  },
  {
    title: 'วันที่แก้ไข',
    dataIndex: 'updated_at'
  },
  {
    title: 'Tags',
    render: (app) => {
      const tag_list = app.tag_list
      const grayStyle = { filter: 'grayscale(100%)' }

      return (
        <>
          <img src={close_loan} style={tag_list.includes('ข้อมูลเรียบร้อย') ? {} : grayStyle} />
          <img src={debt} style={tag_list.includes('แผนสำเร็จ') ? {} : grayStyle} />
          <img src={noburo_heart} style={tag_list.includes('คะแนนผ่าน') ? {} : grayStyle} />
          <img src={mission} style={tag_list.includes('ภารกิจผ่าน') ? {} : grayStyle} />
        </>
      )
    }
  },
  {
    title: () => '',
    render: (app) => (
      <a href={`/admins/applications/${app.id}`}>
        <EyeOutlined />
      </a>
    )
  }
];

export { columns }
